import axios from "axios";
import Cookies from "js-cookie";
import { setIsUserLoggedIn, logout } from "../modules/login/redux/loginSlice";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "";
let store;

export const injectStore = (_store) => {
  store = _store;
};

function getCSRFToken() {
  return document.cookie
    ?.split("; ")
    ?.find((row) => row.startsWith("x-csrf-token="))
    ?.split("=")[1];
}

const createAxiosInstance = (baseURL) =>
  axios.create({
    baseURL,
    headers: {
      "Content-Type": "application/json",
      "x-csrf-token": getCSRFToken(),
    },
    withCredentials: true,
  });

const axiosInstance = createAxiosInstance(API_BASE_URL + "/backend/api/auth");
const axiosInstanceHelpDesk = createAxiosInstance(
  API_BASE_URL + "/backend/api/help-desk",
);
const axiosUser = createAxiosInstance(API_BASE_URL + "/backend/api/user");
const axiosAccess = createAxiosInstance(API_BASE_URL + "/backend/api/access");
const axiosRegister = createAxiosInstance(
  API_BASE_URL + "/backend/api/register",
);
const axiosDocument = createAxiosInstance(
  API_BASE_URL + "/backend/api/document",
);
const axiosFile = createAxiosInstance(API_BASE_URL + "/backend/api/file");
const axiosDashboard = createAxiosInstance(
  API_BASE_URL + "/backend/api/dashboard",
);
const axiosROW = createAxiosInstance(API_BASE_URL + "/backend/api/row");
const axiosApplication = createAxiosInstance(
  API_BASE_URL + "/backend/api/application",
);
const axiosPayment = createAxiosInstance(API_BASE_URL + "/backend/api/payment");
const axiosEsign = createAxiosInstance(API_BASE_URL + "/backend/api/esign");
const axiosAuthority = createAxiosInstance(
  API_BASE_URL + "/backend/noc/authority",
);

const axiosLegacy = createAxiosInstance(API_BASE_URL + "/backend/api/legacy");

const axiosBackend = createAxiosInstance(API_BASE_URL + "/backend/api");

const axiosClarification = createAxiosInstance(
  API_BASE_URL + "/backend/api/clarification",
);

const instances = [
  axiosInstance,
  axiosInstanceHelpDesk,
  axiosUser,
  axiosAccess,
  axiosDocument,
  axiosFile,
  axiosDashboard,
  axiosApplication,
  axiosROW,
  axiosPayment,
  axiosEsign,
  axiosRegister,
  axiosAuthority,
  axiosLegacy,
  axiosBackend,
  axiosClarification,
];

instances.forEach((instance) => {
  instance.interceptors.request.use(
    (config) => {
      if (store) {
        const state = store.getState();
        const token = state?.login?.token;
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        }
      }
      return config;
    },
    (error) => Promise.reject(error),
  );

  instance.interceptors.response.use(
    (response) => {
      if (response.data && response.data.refreshToken) {
        // Update the refresh token in storage if needed
      }
      return response;
    },
    (error) => {
      if (error.response) {
        const { status, data } = error.response;
        if (status === 401) {
          // Add a short-lived handler to swallow any unhandled promise rejection
          const handleUnhandledRejection = (ev) => {
            try {
              ev.preventDefault && ev.preventDefault();
            } catch (e) {}
          };
          window.addEventListener(
            "unhandledrejection",
            handleUnhandledRejection,
          );
          // Navigate to a dedicated 401 page. Use replace so history isn't polluted.
          window.location.replace("/");
          // Dispatch logout and clear storage
          if (store) {
            console.log("Dispatching logout action due to 401 Unauthorized");
            store.dispatch(setIsUserLoggedIn(false));
            store.dispatch(logout({}));
          }
          localStorage.clear();
          // Remove the temporary handler after a short delay
          setTimeout(() => {
            window.removeEventListener(
              "unhandledrejection",
              handleUnhandledRejection,
            );
          }, 3000);
        } else if (status === 403) {
          if (store) {
            store.dispatch(setIsUserLoggedIn(false));
          }
          console.error("Forbidden access");
        } else if (status === 500) {
          console.error("Server error", data);
        } else {
          console.error("Error response", data);
        }
      } else if (error.request) {
        window.location.href = "/";
        console.error("No response received", error.request);
      } else {
        window.location.href = "/";
        console.error("Error", error.message);
      }
      return Promise.reject(error);
    },
  );
});

export {
  axiosInstance,
  axiosInstanceHelpDesk,
  axiosUser,
  axiosAccess,
  axiosDocument,
  axiosFile,
  axiosDashboard,
  axiosROW,
  axiosApplication,
  axiosPayment,
  axiosEsign,
  axiosRegister,
  axiosAuthority,
  axiosLegacy,
  axiosBackend,
  axiosClarification,
};
